import {  Enum  } from "./Enum";

export const OrderStatusEnum: Enum[] = [
  { id: 'pending', name: 'Pending' },
  { id: 'processing', name: 'Processing' },
  { id: 'complete', name: 'Complete' },
  { id: 'canceled', name: 'Canceled' },
  { id: 'closed', name: 'Closed' },
  { id: 'backorder', name: 'Backorder' },
  { id: 'fraud', name: 'Fraud' },
  { id: 'onhold', name: 'Onhold' },
  { id: 'shipped', name: 'Shipped' },
  { id: 'reserve', name: 'Reserve' },
  { id: 'pending_payment', name: 'Pending Payment' },
  { id: 'processing', name: 'Processing' },
  { id: 'request', name: 'Request' },
  { id: 'shipped_cfa', name: 'Shipped CFA' },
  { id: 'delivered', name: 'Delivered' },
  { id: 'requested_refund', name: 'Requested Refund' },
  { id: 'na_reserve', name: 'NA Request' },
  { id: 'expired', name: 'Expired' },
];
